module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-7-2.8f600ee4.png";